import { derivativesRoutePaths } from './paths';

import type { RouteObject } from 'react-router-dom';

export const derivativesRoute: RouteObject[] = [
  {
    path: derivativesRoutePaths.list.path,
    async lazy() {
      const Page = await import('@/pages/derivatives/DerivativesPage');
      return { Component: Page.default };
    },
  },
  {
    path: derivativesRoutePaths.detail.path,
    async lazy() {
      const Page = await import('@/pages/derivatives/DerivativesDetailPage');
      return { Component: Page.default };
    },
  },
];
